/* eslint-disable simple-import-sort/imports */
import "../../styles/base.scss";
import "../../components/welcomeScreen/welcome.scss";

import { List } from "immutable";
import PropTypes from "prop-types";
import PubSub from "pubsub-js";
import React, { PureComponent } from "react";
import { connect } from "react-redux";

import SplitView from "../../components/splitView";
import pubSubTopics from "../../constants/pubSubTopics";
import { welcomeOperations, welcomeSelectors } from "../../modules/welcome";
import { isNativeCommsInstalled, nativeCommsBroadcastMessageTypes } from "../../nativeComms";
import { immutableRecords } from "../../types";
import { mergeDispatchToProps } from "../../utils/codeSplit";
import { trackEvent } from "../../utils/trackAnalytics";
import WelcomeLeftContainer from "./WelcomeLeftContainer";
import WelcomeRightContainer from "./WelcomeRightContainer";
import AppShared from "../app/App.shared";

//#!if ENV !== "production"
// import { recentFiles } from "../../testInBrowser/initialState";
//#!endif

//#!if harvard !== true
// import TemplateWizard from "./templateWizard";
// import UpgradeWizard from "./upgradeWizard";
//#!endif

const leftSplitConstraints = List([
  immutableRecords.SplitConstraintsRecord({
    minSize: 230,
    preferredSize: 350,
    hasDivider: true,
    canResize: true,
    canCollapse: true
  }),
  immutableRecords.SplitConstraintsRecord({
    minSize: 200
  })
]);

const welcomeSplitView = (onCreateNew, onOpenExistingFile) => {
  return (
    <SplitView vertical={true} hasShadow={true} constraints={leftSplitConstraints}>
      <WelcomeLeftContainer onCreateNew={onCreateNew} onOpenExistingFile={onOpenExistingFile} />
      <WelcomeRightContainer />
    </SplitView>
  );
};

class WelcomeScreen extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
    this.onCreateNew = this.onCreateNew.bind(this);
    this.onOpenExistingFile = this.onOpenExistingFile.bind(this);
    this.onTemplateWizardClose = this.onTemplateWizardClose.bind(this);
    this.onUpgradeWizardClose = this.onUpgradeWizardClose.bind(this);
  }

  componentDidMount() {
    //#!if ENV !== "production"
// if (!isNativeCommsInstalled()) {
// window.setTimeout(() => this.props.showDefaultRecentFiles(), 100);
// }
    //#!endif
    trackEvent("welcomeScreenPageview", "welcomeScreen");
  }

  onCreateNew() {
    trackEvent("templateWizardOpen", "templateWizard");
    this.props.onShowTemplateWizard();
  }

  onOpenExistingFile() {
    trackEvent("openExistingFile", "welcomeScreen");
    if (isNativeCommsInstalled()) {
      PubSub.publish(pubSubTopics.sendNativeMessage, {
        msg: nativeCommsBroadcastMessageTypes.WELCOME_OPEN_EXISTING_FILE
      });
    } else {
      //#!if ENV !== "production"
// this.props.showDefaultRecentFiles();
      //#!endif
    }
  }

  onTemplateWizardClose() {
    trackEvent("templateWizardClose", "templateWizard");
    this.props.onHideTemplateWizard();
  }

  onUpgradeWizardClose() {
    trackEvent("upgradeWizardClose", "templateWizard");
    this.setState({ showUpgradeWizard: false });
    this.props.onHideUpgradeWizard();

    if (isNativeCommsInstalled()) {
      PubSub.publish(pubSubTopics.sendNativeMessage, {
        msg: nativeCommsBroadcastMessageTypes.UPGRADE_WIZARD_CANCELLED
      });
    }
  }

  render() {
    return (
      <div className="aeonWelcome">
        {this.props.showLoadingFile
          ? AppShared.createLoadingDiv()
          : welcomeSplitView(this.onCreateNew, this.onOpenExistingFile)}
        {this.props.showTemplateWizard ? (
          <TemplateWizard onCloseClick={this.onTemplateWizardClose} onDoneClick={this.onTemplateWizardClose} />
        ) : null}
        {this.props.showUpgradeWizard ? (
          <UpgradeWizard onCloseClick={this.onUpgradeWizardClose} onDoneClick={this.onUpgradeWizardClose} />
        ) : null}
      </div>
    );
  }
}

WelcomeScreen.propTypes = {
  //#!if ENV !== "production"
// showDefaultRecentFiles: PropTypes.func.isRequired,
  //#!endif
  //#!if harvard !== true
// showUpgradeWizard: PropTypes.bool.isRequired,
// onHideUpgradeWizard: PropTypes.func.isRequired,
// showTemplateWizard: PropTypes.bool.isRequired,
// onShowTemplateWizard: PropTypes.func.isRequired,
// onHideTemplateWizard: PropTypes.func.isRequired,
// showLoadingFile: PropTypes.bool.isRequired
  //#!endif
};

const mapStateToProps = state => {
  return {
    showUpgradeWizard: welcomeSelectors.getShowUpgradeWizard(state.present),
    showTemplateWizard: welcomeSelectors.getShowTemplateWizard(state.present),
    showLoadingFile: welcomeSelectors.getShowLoadingFile(state.present)
  };
};

const readonlyActions = {
  //#!if ENV !== "production"
// showDefaultRecentFiles: () => welcomeOperations.updateRecentFiles(recentFiles),
  //#!endif
  //#!if harvard !== true
// onHideUpgradeWizard: welcomeOperations.hideUpgradeWizard
  //#!endif
};

const editingActions = {
  onShowTemplateWizard: welcomeOperations.showTemplateWizard,
  onHideTemplateWizard: welcomeOperations.hideTemplateWizard
};

const mapDispatchToProps = dispatch => mergeDispatchToProps(readonlyActions, editingActions, dispatch);

const connectedApp = connect(mapStateToProps, mapDispatchToProps)(WelcomeScreen);

export default connectedApp;
